// Variant ID for Sunscreen Sachet is 50894444658966
// Variant ID for Aloe Invisible Sunscreen is 50501007048982
// Variant ID for Argan Hydrating Moisturiser is 50501006098710
// Variant ID for Green Tea Revitalising Cleanser is 50501007278358
// Variant ID for Moisturiser Sachet is 50894444757270
// Variant ID for Cleanser Sachet is 50894444691734
function addSample() {
  const sunscreen_variant_id = "50501007048982";
  const moisturiser_variant_id = "50501006098710";
  const cleanser_variant_id = "50501007278358";
  const sunscreen_sachet_variant_id = "50894444658966";
  const moisturiser_sachet_variant_id = "50894444757270";
  const cleanser_sachet_variant_id = "50894444691734";
  fetch("/cart.json")
    .then((res) => res.json())
    .then((data) => {
      const cart_items = data.items;

      let has_sunscreen = false;
      let has_moisturiser = false;
      let has_cleanser = false;
      let has_sunscreen_sachet = false;
      let has_moisturiser_sachet = false;
      let has_cleanser_sachet = false;

      cart_items.forEach((item) => {
        if (item.variant_id == sunscreen_variant_id) {
          has_sunscreen = true;
        }
        if (item.variant_id == moisturiser_variant_id) {
          has_moisturiser = true;
        }
        if (item.variant_id == cleanser_variant_id) {
          has_cleanser = true;
        }
      });

      // Add sunscreen sachet if sunscreen is not in cart or a customer has never bought it before
      let itemsToUpdate = [];
      if (!has_sunscreen && !has_sunscreen_sachet) {
        itemsToUpdate = [
          { id: sunscreen_sachet_variant_id, quantity: 1 },
          { id: moisturiser_sachet_variant_id, quantity: 0 },
          { id: cleanser_sachet_variant_id, quantity: 0 },
        ];
        has_sunscreen_sachet = true;
      } else if (!has_moisturiser && !has_moisturiser_sachet) {
        // Add moisturiser sachet if moisturiser is not in cart or a customer has never bought it before
        itemsToUpdate = [
          { id: sunscreen_sachet_variant_id, quantity: 0 },
          { id: moisturiser_sachet_variant_id, quantity: 1 },
          { id: cleanser_sachet_variant_id, quantity: 0 },
        ];
        has_moisturiser_sachet = true;
      } else if (!has_cleanser && !has_cleanser_sachet) {
        itemsToUpdate = [
          { id: sunscreen_sachet_variant_id, quantity: 0 },
          { id: moisturiser_sachet_variant_id, quantity: 0 },
          { id: cleanser_sachet_variant_id, quantity: 1 },
        ];
        has_cleanser_sachet = true;
      }

      // If all products are in cart, add sunscreen sachet by default
      if (
        has_sunscreen &&
        has_moisturiser &&
        has_cleanser &&
        !has_sunscreen_sachet &&
        !has_moisturiser_sachet &&
        !has_cleanser_sachet
      ) {
        itemsToUpdate = [
          { id: sunscreen_sachet_variant_id, quantity: 1 },
          { id: moisturiser_sachet_variant_id, quantity: 0 },
          { id: cleanser_sachet_variant_id, quantity: 0 },
        ];
      }

      if (itemsToUpdate.length > 0) {
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: itemsToUpdate.reduce((acc, item) => {
              acc[item.id] = item.quantity;
              return acc;
            }, {}),
          }),
        }).then((res) => {
          if (res.ok) {
            console.log("Sample sachet added to cart.");
          } else {
            console.error("Failed to add sample sachet to cart.");
          }
          // Refreh theme cart UI if necessary
          // document.dispatchEvent(
          //   new CustomEvent("theme:cart:refresh", {
          //     detail: {
          //       target: "coupon_validate",
          //     },
          //     bubbles: true,
          //   })
          // );
        });
      }
    });
}

// When shopify cart changes, run the addSample function
document.addEventListener("cart:updated", function () {
  addSample();
});

// Initial run when the script loads
addSample();
